import React from 'react';
import { cn } from './_cn';

const variants = {
  default: 'text-xs font-medium text-slate-500 dark:text-slate-400',
  micro:
    'text-[0.65rem] font-semibold uppercase tracking-[0.15em] text-slate-500 dark:text-slate-400',
};

const FieldLabel = ({
  children,
  icon: Icon,
  required = false,
  variant = 'default',
  htmlFor,
  className = '',
}) => (
  <label
    htmlFor={htmlFor}
    className={cn(
      'mb-1.5 flex items-center gap-1.5',
      variants[variant] || variants.default,
      className,
    )}
  >
    {Icon ? (
      <Icon
        className="h-3.5 w-3.5 shrink-0 text-slate-400 dark:text-slate-500"
        aria-hidden
      />
    ) : null}
    <span>{children}</span>
    {required ? <span className="text-rose-500">*</span> : null}
  </label>
);

export default FieldLabel;
